import Form from 'react-bootstrap/Form';
import React, { useState, useEffect } from "react"
import {useNavigate} from 'react-router-dom';
import PanelDisplayImage from '../components/panel/PanelDisplayImage.js';
import TitleDiv from '../components/shared/TitleDiv.js';
import FailIconDiv from '../components/fail/FailIconDiv.js';
import FailMsgDiv from '../components/fail/FailMsgDiv.js';
import SuccessMsgDiv from '../components/fail/SuccessMsgDiv.js';
import EnquiryDiv from '../components/fail/EnquiryDiv.js';
import ReceivedSmsDiv from '../components/fail/ReceivedSmsDiv.js';
import LongButton from '../components/shared/LongButton.js';
import PanelDisplayStockinfo from '../components/panel/PanelDisplayStockinfo.js';
import '../css/PaymentResult.css';

function PaymentResult(props) {
    const navigate = useNavigate();
    const PUBLIC_URL = process.env.PUBLIC_URL;
    const url = new URL(window.location.href);
    let baseUrl = `${url.protocol}//${url.host}/`;

    if (process.env.REACT_APP_API_URL != ""){
      baseUrl = process.env.REACT_APP_API_URL;
    }
    
    let paymentUrl = baseUrl + "frontend/api/Enroll/GetPaymentResult";
    const bgColor = process.env.REACT_APP_BG_COLOR;
    const iconUrl = baseUrl + "frontend/api/Enroll/GetImageURLbyStatus";
    const eventUrl = baseUrl + "frontend/api/Enroll/GetEventStatus";
    const imgStep3 = process.env.REACT_APP_URL_IMAGE + "step-03.png";
    const eventName = window.name;
    const [itemDetails, setItemDetails] = useState([]);
    const [content, setContent] = useState({
      Status: "",
      Title: "",
      Icon: "",
      Geocode: "",
      Mobile: "",
      Invoice_no: "",
      Created_Date: "",
      Item_Currency: "",
      Item_Subtotal: "",
      Item_Total: "",
      AllButton_Color: "#FFFFFF",
      AllButton_FontColor: "#FFFFFF",
      AllTitle_Color: "#FFFFFF",
      AllTitle_FontColor: "#FFFFFF",
      AllBackground_Color: "#FFFFFF",
      Event_Version : ""
    });

    if(props.isdebugmode) console.log(baseUrl);
    
    if(props.invoiceno === "" || props.hash === ""){
      navigate('../' + PUBLIC_URL + '/fail-wrong-url');
    } 
    
    if (props.invoiceno.length == 28){
      paymentUrl += "_v2";
      if(props.isdebugmode) console.log(paymentUrl);
    }

    const eventButtonOnClick = (e) => {
      navigate('../' + PUBLIC_URL + '/' + eventName + '/enroll');
    };
    
    useEffect(() => {
      fetch(paymentUrl, {
        "method": "POST",
        "headers": {
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          "invoice_number": props.invoiceno,
          "hash" : props.hash
        })
      })
      .then(response => response.json())
      .then(response => { 
        let result = JSON.parse(JSON.stringify(response));
        if(props.isdebugmode) console.log(result);
        if (result.IsSuccess == null){
          setContent(previousState => {
            return { 
              ...previousState,
              Status : result.Status,
              Title : result.Title,
              Geocode : result.Geocode,
              Mobile : result.Mobile,
              Invoice_no : result.Invoice_no,
              Created_Date : result.Created_Date,
              Item_Currency : result.Item_Currency,
              Item_Subtotal : result.Item_Subtotal,
              Item_Total : result.Item_Total
            }
          });
  
          let items = []; 
          for (let i = 0; i < result.Item_Detail.length; i++)
          {
            items.push(result.Item_Detail[i]);
          }
          setItemDetails(items);
        } else {
          navigate('../' + PUBLIC_URL + '/fail-wrong-url');
        }
      })
      .catch(err => { 
        navigate('../' + PUBLIC_URL + '/' + eventName + '/fail-error');
       });
    }, []);
    
    useEffect(() => {
      fetch(iconUrl, {
        "method": "POST",
        "headers": {
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          "Event_Name": eventName,
          "Status": content.Status === "PAID" ? "Success" : "Fail"
        })
      })
      .then(response => response.json())
      .then(response => { 
        let result = JSON.parse(JSON.stringify(response));
        if(props.isdebugmode) console.log(result.url);        

        if(content.Status === "PAID"){
          if(props.isdebugmode) console.log(window.QueueIt);
          window.isSubmitSuccesful = "yes";
          window.QueueIt && window.QueueIt.validateUser();
        }

        setContent(previousState => {
          return { 
            ...previousState,
            Icon : result.url
          }
        });
      })
      .catch(err => { 
        if(props.isdebugmode) console.log(err);
        navigate('../' + PUBLIC_URL + '/' + eventName + '/fail-error');
      });
    }, [content.Status]);

    useEffect(() => {
      fetch(eventUrl, {
        "method": "POST",
        "headers": {
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          "event_Name": eventName
        })
      })
      .then(response => response.json())
      .then(response => { 
        let result = JSON.parse(JSON.stringify(response));
        if(props.isdebugmode) console.log(result);
        if (result.IsSuccess == null){
          setContent(previousState => {
            return { 
              ...previousState,
              AllButton_Color : result.AllButton_Color,
              AllButton_FontColor : result.AllButton_FontColor,
              AllTitle_Color : result.AllTitle_Color,
              AllTitle_FontColor : result.AllTitle_FontColor,
              AllBackground_Color : result.AllBackground_Color,
              Event_Version : result.Event_Version
            }
          });

          // Redirect to enroll page if it is not payment event
          if (result.Event_Version == 3){
            navigate('../' + PUBLIC_URL + '/' + eventName + '/enroll');
          }

        } else {
          navigate('../' + PUBLIC_URL + '/fail-wrong-url');
        }
      })
      .catch(err => { 
        navigate('../' + PUBLIC_URL + '/' + eventName + '/fail-error');
        console.log(err); 
       });

    }, []);

    let successMsg = "請耐心等候樓上®透過短訊向您的手提電話號碼 " + content.Geocode + "-" + content.Mobile + " 發送的預購印花連結。";
    
  return (
    <>
    {content.Status === "PAID" &&
      <Form style={{backgroundColor: content.AllBackground_Color}}>
          <TitleDiv class="title" title="成功預購" bgColor={content.AllTitle_Color} fontColor={content.AllTitle_FontColor}></TitleDiv>
          <div className="d-grid">
              <PanelDisplayImage imagesrc={imgStep3}></PanelDisplayImage>
              <FailIconDiv class="icon" src={content.Icon} />
              <SuccessMsgDiv class="icon" msg="多謝您！成功預購！"></SuccessMsgDiv>
              <SuccessMsgDiv class="info" msg={successMsg}></SuccessMsgDiv>
              <div>
                <PanelDisplayStockinfo data={content} stock={itemDetails}></PanelDisplayStockinfo>
              </div>
              <ReceivedSmsDiv class="info"></ReceivedSmsDiv>
              <EnquiryDiv class="info" msg="若您無法完成預購訂單或未收到取貨連結短訊，請致電顧客服務熱線查詢(上午9:00 至 晚上9:00)："></EnquiryDiv>
          </div>
      </Form>
    } 
    {content.Status !== "PAID" &&
      <Form style={{backgroundColor: content.AllBackground_Color}}>
          <TitleDiv class="title" title="未能完成預購" bgColor={content.AllTitle_Color} fontColor={content.AllTitle_FontColor}></TitleDiv>
          <div className="d-grid">
              <FailIconDiv class="icon" src={content.Icon} />
              <FailMsgDiv class="icon" msg="未能成功完成付款程序，訂單將自動取消。請選擇以下選項。"></FailMsgDiv>
              <div className="msg">
                <LongButton text="返回預購首頁" bgColor={content.AllButton_Color} fontColor={content.AllButton_FontColor} onClick={() => { eventButtonOnClick(); }}></LongButton>
              </div>
              <EnquiryDiv class="info" msg="若您無法完成預購訂單或未收到取貨連結短訊，請致電顧客服務熱線查詢(上午9:00 至 晚上9:00)："></EnquiryDiv>
          </div>
      </Form>
    }
    </>
  );
}

export default PaymentResult;
